import * as React from 'react';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';
import {SelectValue} from "antd/lib/select";
import AutoCompleteInput from "../input/AutoCompleteInput";
import locales from "../../locales";

interface Props extends BaseFormItemProps {
  dataSource: string[];
  value?: string;
  disabled?: boolean;
  onChange?: (value: SelectValue) => void;
  className?: string;
  allowClear?: boolean;
  validateOnDataSource?: boolean;
}

class AutoCompleteFormItem extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {dataSource, disabled, onChange, value, className, allowClear} = this.props;

    return <BaseFormItem
      {...this.props}
      rules={[{validator: this.validate}]}
      input={
        <AutoCompleteInput
          className={className || 'mild-disabled'}
          dataSource={dataSource}
          disabled={disabled}
          onChange={onChange}
          value={value}
          allowClear={allowClear}
        />
      }
    />;
  }

  private validate = (_: any, value: string, callback: (message?: string) => void) => {
    if (!value) {
      callback();
      return;
    }

    // If the value do not need to be validated on the datasource, or the value is included in the data source, then it is valid
    if (!this.props.validateOnDataSource || this.props.dataSource.includes(value)) {
      callback();
      return;
    }

    callback(locales.invalid_input);
  };
}

export default AutoCompleteFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/AutoCompleteFormItem.tsx